import type { Emoji, EmojiMartData } from "@emoji-mart/data";
import emojiData from "@emoji-mart/data";
import { Index } from "flexsearch";

import { EMOJI_BLACKLIST, ORDERED_ICONS } from "./avatar-picker.constants";

const data = emojiData as unknown as EmojiMartData;

// --- Emoji search index (built once at module load) ---

const emojiIndex = new Index({ tokenize: "full" });
for (const emoji of Object.values(data.emojis)) {
  emojiIndex.add(emoji.id, emoji.keywords?.join(" ") || emoji.name);
}

export function searchEmojis(query: string): Emoji[] {
  return (emojiIndex.search(query) as string[])
    .map((id) => data.emojis[id])
    .filter(Boolean) as Emoji[];
}

// --- Emoji categories (built once at module load) ---

export const emojiCategories = data.categories.reduce<Record<string, Emoji[]>>(
  (acc, category) => {
    acc[category.id] = category.emojis.reduce<Emoji[]>((list, emojiId) => {
      if (!EMOJI_BLACKLIST.includes(emojiId)) {
        const emoji = data.emojis[emojiId];
        if (emoji) list.push(emoji);
      }
      return list;
    }, []);
    return acc;
  },
  {},
);

// --- Custom icon search index (built once at module load) ---
// Uses the icon name as the search term (splitting on hyphens)

const iconIndex = new Index({ tokenize: "full" });
for (const icon of ORDERED_ICONS) {
  iconIndex.add(icon, icon.replace(/-/g, " "));
}

export function searchIcons(query: string): Set<string> {
  return new Set(iconIndex.search(query) as string[]);
}

// --- Helpers ---

export function cleanName(name: string | undefined): string | undefined {
  if (!name) return undefined;
  return name
    .replace(/-/g, " ")
    .replace(/([a-zA-Z])(\d)/g, "$1 $2")
    .replace(/^./, (c) => c.toUpperCase());
}
